import useTitle from '@shared/hooks/useTitle';
import { useAuth } from '@features/auth/contexts/AuthContext';
import ClientDashboard from "./client-dashboard";
import AdminDashboard from "./admin-dashboard";
import ManagerDashboard from "./manager-dashboard";
import ComprehensiveLivreurDashboard from "@/features/packages/components/ComprehensiveLivreurDashboard";
import ClientSupportDashboard from "@features/client-support/pages/ClientSupportDashboard";

export default function Dashboard() {
  const auth = useAuth();
  useTitle("Dashboard");

  // If user is a client, show the client-specific dashboard
  if (auth.isClient) {
    return <ClientDashboard />;
  }

  if (auth.isDeliveryPerson) {
    // If user is a livreur, show the livreur dashboard
    return <ComprehensiveLivreurDashboard />;
  }

  if (auth.isClientSupport) {
    // If user is a client support, show the client support dashboard
    return <ClientSupportDashboard />;
  }

  if (auth.isManager) {
    // If user is a manager, show the manager-specific dashboard
    return <ManagerDashboard />;
  }

  // Otherwise show the admin dashboard
  return <AdminDashboard />;
}
